import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Sticky, Tag, QuantitySelector, StickyCallToAction, Price } from '@grandvisionhq/common';
import { Hr } from '@grandvisionhq/elements';
import { useProductDetailSlots, ProductDetailTitleView, ProductDetailPrice, ProductDiscountLabel, Discount, ProductDetailUspsView, ProductDetailDisclaimerView } from '@grandvisionhq/fun-products';
import { StockIndicator } from '@grandvisionhq/inventory';
import { ReviewSnippet } from '@grandvisionhq/reviews';
import { DeliveryIndicator } from '@grandvisionhq/shipping';
import { useFeatureToggles, useIntl } from '@grandvisionhq/state';
import Description from './Components/Description/Description.js';

const Solutions = ({ addToCartRef , availableQuantity , ctaButton , stickyTop , currency , brandLink , isSmallScreen , isProductLabelEnabled , labels , showStickyButton , productTypeUsps , variant , brandModel , descriptionConfig , packageSelector , selectedQuantity , onDecreaseQuantity , onIncreaseQuantity , isOrderable , maxOrderableQuantity , productImageGallery , disclaimer , quantity ,  })=>{
    const { isDeliveryFullDateEnabled  } = useFeatureToggles();
    const { getLabel  } = useIntl();
    const { Slots  } = useProductDetailSlots();
    var _discountedPrice;
    return /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__main product-detail-solutions"
    }, isSmallScreen && /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__header--mobile"
    }, /*#__PURE__*/ React.createElement(ProductDetailTitleView, {
        title: `${variant.modelName} ${brandModel}`,
        subtitle: variant.brand,
        href: brandLink
    }), /*#__PURE__*/ React.createElement(ReviewSnippet, {
        className: "product-detail__review-snippet",
        productId: variant.sku
    })), /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__image-gallery"
    }, productImageGallery), /*#__PURE__*/ React.createElement("section", {
        className: "product-detail__aside",
        "aria-label": `${variant.modelName} ${variant.modelName}`
    }, /*#__PURE__*/ React.createElement(Sticky, {
        top: stickyTop || 0,
        bottomBoundary: ".product-detail",
        enabled: !isSmallScreen
    }, /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "mobile-hidden"
    }, /*#__PURE__*/ React.createElement(ProductDetailTitleView, {
        title: `${variant.modelName} ${brandModel}`,
        subtitle: variant.brand,
        href: brandLink
    })), !isProductLabelEnabled && variant.tag && variant.tag.value && /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__product-tag"
    }, /*#__PURE__*/ React.createElement(Tag, {
        iconKey: variant.tag.key,
        label: variant.tag.value
    })), !!variant.price && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__specification-prices",
        role: "group",
        "aria-label": getLabel('products.screenreader.priceInformation')
    }, /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__price-container"
    }, /*#__PURE__*/ React.createElement(ProductDetailPrice, {
        originalPrice: variant.price.originalPrice,
        discountedPrice: variant.price.discountedPrice,
        currency: currency
    })), isProductLabelEnabled && /*#__PURE__*/ React.createElement(ProductDiscountLabel, {
        title: variant.discountText
    }), !isProductLabelEnabled && variant.discounted && /*#__PURE__*/ React.createElement(Discount, {
        label: variant.discountText,
        discount: variant.discounted,
        isWide: true
    })), Slots.AfterPrice ? /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__after-price-slot"
    }, /*#__PURE__*/ React.createElement(Slots.AfterPrice, null)) : null), !isSmallScreen && /*#__PURE__*/ React.createElement(ReviewSnippet, {
        className: "product-detail__review-snippet",
        productId: variant.sku
    }), packageSelector, /*#__PURE__*/ React.createElement("div", {
        className: "product-detail-solutions__quantity-picker"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "product-detail-solutions__quantity-picker__label"
    }, labels.selectAmount), /*#__PURE__*/ React.createElement("div", {
        className: "product-detail-solutions__quantity-picker__wrapper"
    }, /*#__PURE__*/ React.createElement(QuantitySelector, {
        quantity: selectedQuantity || 1,
        minimumQuantity: 1,
        maximumQuantity: maxOrderableQuantity,
        onDecreaseQuantity: onDecreaseQuantity,
        onIncreaseQuantity: onIncreaseQuantity,
        isDisabled: !isOrderable
    }), /*#__PURE__*/ React.createElement(StockIndicator, {
        stockCount: availableQuantity,
        allowBackOrder: isOrderable,
        channelAvailability: variant.channelAvailability
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__cart-details"
    }, isDeliveryFullDateEnabled && /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__cart-details__delivery-indicator"
    }, /*#__PURE__*/ React.createElement(DeliveryIndicator, {
        view: "text",
        items: [
            {
                sku: variant.sku,
                quantity
            }
        ]
    })), /*#__PURE__*/ React.createElement("div", {
        ref: addToCartRef
    }, ctaButton), Slots.AfterCTA ? /*#__PURE__*/ React.createElement(Slots.AfterCTA, null) : null), isSmallScreen && showStickyButton && variant.price && /*#__PURE__*/ React.createElement(StickyCallToAction, {
        button: ctaButton,
        price: /*#__PURE__*/ React.createElement(Price, {
            value: (_discountedPrice = variant.price.discountedPrice) !== null && _discountedPrice !== void 0 ? _discountedPrice : variant.price.originalPrice,
            currency: currency,
            centAmount: true
        })
    }), productTypeUsps && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Hr, {
        className: "product-detail__usp-divider"
    }), /*#__PURE__*/ React.createElement(ProductDetailUspsView, {
        items: productTypeUsps
    }))))), /*#__PURE__*/ React.createElement("div", {
        className: "product-detail-solutions__description"
    }, /*#__PURE__*/ React.createElement(Description, swcHelpers.extends({}, descriptionConfig, {
        variant: variant
    }))), disclaimer && /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__disclaimer product-detail-lenses__disclaimer"
    }, /*#__PURE__*/ React.createElement(ProductDetailDisclaimerView, {
        disclaimer: disclaimer
    })));
};
var Solutions$1 = Solutions;

export { Solutions, Solutions$1 as default };
//# sourceMappingURL=Solutions.js.map
